import { render, staticRenderFns } from "./DispensationApplicationDetails.vue?vue&type=template&id=d125b8e8&scoped=true&"
import script from "./DispensationApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./DispensationApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispensationApplicationDetails.vue?vue&type=style&index=0&id=d125b8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d125b8e8",
  null
  
)

export default component.exports